import React, { useEffect } from 'react';
import { Typography } from '@mui/material';
import Game from '../game/Game';
import { useModal } from '../../context/ModalContext';
import Layout from './Layout';
import { useGame } from '../../context/GameContext';
import WinModal from '../modals/WinModal';

function DemoPage() {
  const { openModal } = useModal();
  const { gameState, setGameState, setMode } = useGame();
  const { closeModal, activeModal } = useModal();

  useEffect(() => {
    setMode('demo');
  }, [setMode]);

  if (!gameState) return null;

  return (
    <Layout>
      <WinModal isOpen={activeModal === 'win'} onClose={closeModal} />
      <div>
        <Typography className="demo-text">
          Use the arrow keys or mouse to guide the worm and spell a related word
          on each row. Letters appear in the order shown at the bottom of the
          screen. If you make a mistake, tap the worm to move backwards, or hit{' '}
          <b>“reset tiles”</b>.
        </Typography>

        <Game
          gameState={gameState}
          setGameState={setGameState}
          resultsOnClick={() => openModal('win')}
        />

        <Typography className="demo-text" sx={{ marginTop: 2 }}>
          Can you figure out the theme? If you need some help, <b>use a hint</b>{' '}
          to reveal a letter.
        </Typography>
      </div>
    </Layout>
  );
}

export default DemoPage;
